import {
  BIM_BUCKET_DETAILS,
  BIM_FOLDERS_ITEMS,
  BIM_ERROR,
  BIM_LIST,
  BIM_LOGIN,
  BIM_PROJECTS,
  BIM_LOADING,
  BIM_ADD_STACK,
  BIM_POP_STACK,
} from "../../typesAction";

const INITIAL_STATE = {
  auth: false,
  message: "... ee",
  inProgress: true,
  models: [],
  bucket: {},
  progress: null,
  projects: [],
  isLoading: false,
  stack: [],
};

export default function (state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case BIM_LOGIN:
      return {
        ...state,
        auth: action.payload,
        message: "... completed",
      };

    case BIM_LIST:
      return {
        ...state,
        models: action.payload.models,
        message: "message",
      };
    case BIM_BUCKET_DETAILS:
      return {
        ...state,
        bucket: action.payload.bucket,
        message: "bim_bucket_created",
      };
    case "bim_progress":
      return {
        ...state,
        progress: action.payload.progress,
        message: "bim_bucket_created",
      };
    case BIM_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        auth: false,
        message: "... error",
      };
    case BIM_FOLDERS_ITEMS:
      return {
        ...state,
        folderItems: action.payload.folderItems,
        message: "message",
      };
    case BIM_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        message: "message",
      };
    case BIM_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case BIM_ADD_STACK:
      return {
        ...state,
        stack: [...state.stack, action.payload],
      };
    case BIM_POP_STACK:
      const result = [...state.stack];
      result.pop();
      return {
        ...state,
        stack: result,
      };

    default:
      return state;
  }
}
